import { User } from '../objects/user';
import { Constructor } from './constructor';
import { DatabaseRecord } from './database-record';

/**
 * The HasActivityLogs mixin. Adds the logs property to the class
 * @returns The class with the mixin applied
 */
export function HasActivityLogs<T extends Constructor<{}>>(Base: T = class {} as any) {
  return class extends Base {
    /**
     * The activity logs for this model
     */
    public logs: ActivityLog[] = [];
  };
}

/**
 * The ActivityLog model
 */
export class ActivityLog extends DatabaseRecord() {
  /**
   * The user_id of the user who performed the action
   */
  public user_id: number | null = null;

  /**
   * The user who performed the action
   */
  public user?: User = undefined;

  /**
   * The full name of the user who performed the action. Defaults to 'SYSTEM'
   */
  public full_name = 'SYSTEM';

  /**
   * The action that was performed
   */
  public action: string = '';

  /**
   * The message of the action that was performed
   */
  public message: string = '';

  /**
   * The specific details of the action that was performed
   */
  public details?: any[];

  constructor(data?: Partial<ActivityLog>) {
    super(data);
    Object.assign(this, data);

    if (data) {
      if (this.created_at) this.created_at = new Date(this.created_at);
      if (this.updated_at) this.updated_at = new Date(this.updated_at);
      if (this.user) this.user = new User(data.user);
    }
  }
}
